<template>
  <v-dialog v-model="isActive" scrollable persistent>
    <v-card v-if="isActive">
      <div class="card-header-tabs">
        <div @click="changeTab('search')" v-bind:class="[selected_tab === 'search' ? 'selected' : '', 'header-tab']">
          Buscar</div>
        <div @click="changeTab('register')"
          v-bind:class="[selected_tab === 'register' ? 'selected' : '', 'header-tab']">Cadastrar</div>
      </div>
      <v-divider></v-divider>
      <div v-if="selected_tab === 'search'">
        <v-card-title class="px-4">
          Buscar Cliente<v-spacer></v-spacer>
          <v-btn color="primary" depressed outlined @click="skipStep()"> PULAR ETAPA </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-title class="px-4">
          <v-text-field v-model="search_term" v-debounce:1s="getClientList" label="Pesquisar: Nome, Telefone, CPF/CNPJ" outlined
            hide-details></v-text-field>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-if="isLoading" style="overflow: hidden; height: 90px; text-align: center">
            <v-progress-circular class="mt-3" color="#777" size="55" indeterminate></v-progress-circular>
          </div>
          <div v-if="!isLoading && list.length === 0" style="overflow: hidden; height: 90px; text-align: center">
            <v-icon class="mt-3 mb-1" size="40"> mdi-magnify </v-icon><br />
            <span>Utilize o campo acima para pesquisar</span>
          </div>
          <v-radio-group v-if="!isLoading && list.length > 0" v-model="selected" column hide-details class="mt-0">
            <v-radio v-for="client in list" :key="client.id" :value="client.id">
              <template v-slot:label>
                <div>
                  <div style="font-weight: 500;">{{ client.name.toUpperCase() }}</div>
                  <div style="font-size: 14px; color: #666;">{{ formatPhone(client.phone) }}</div>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
      </div>
      <div v-if="selected_tab === 'register'">
        <v-card-title class="px-4"> Cadastrar Cliente </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-radio-group v-model="register_client.gender" :disabled="isLoading" class="mt-0" row>
            <v-radio label="Masculino" value="male"></v-radio>
            <v-radio label="Feminino" value="female"></v-radio>
            <v-radio label="PJ" value="company"></v-radio>
          </v-radio-group>
          <v-text-field v-model="register_client.name" :disabled="isLoading" color="#777" label="*Nome Completo"
            class="pb-4" hide-details outlined></v-text-field>
          <v-text-field v-model="register_client.phone" v-mask="['(##) ####-####', '(##) #####-####']"
            :disabled="isLoading" color="#777" label="*Celular principal" class="pb-4" hide-details
            outlined></v-text-field>
          <v-select v-model="register_client.client_classification_id" :items="client_classifications"
            :disabled="isLoading" item-text="description" item-value="id" label="*Classificação" class="pb-4"
            color="#777" outlined hide-details></v-select>
          <v-text-field v-model="register_client.cpf_cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']"
            :disabled="isLoading" label="CPF ou CNPJ" class="pb-4" color="#777" hide-details outlined></v-text-field>
          <v-text-field v-if="register_client.gender !== 'company'" v-model="register_client.birthdate"
            :disabled="isLoading" v-mask="['##/##/####']" color="#777" label="Data de nascimento" class="pb-4"
            hide-details outlined></v-text-field>
          <v-text-field v-if="register_client.gender !== 'company'" v-model="register_client.profession"
            :disabled="isLoading" color="#777" label="Profissão" class="pb-4" hide-details outlined></v-text-field>

          <div v-if="register_client.gender === 'company'" class="pb-4 password-div">
            <v-text-field v-model="register_client.password" @click:append="show_password = !show_password"
              :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'" :type="show_password ? 'text' : 'password'"
              :disabled="isLoading" color="#777" label="Código de acesso do relatório" hide-details
              outlined></v-text-field>

            <v-tooltip v-if="register_client?.have_password" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-3" color="#48B38B" v-bind="attrs" v-on="on">mdi-check-circle-outline</v-icon>
              </template>
              <span>Código cadastrada! Para alterar digite no campo ao lado</span>
            </v-tooltip>

            <v-tooltip v-if="register_client?.have_password" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="ml-3" v-bind="attrs" v-on="on" @click="removePassword"><v-icon
                    color="#ff6347">mdi-delete</v-icon></v-btn>
              </template>
              <span>Remover código de acesso do cliente</span>
            </v-tooltip>
          </div>
        </v-card-text>
      </div>
      <v-divider></v-divider>
      <v-card-actions v-if="selected_tab === 'search'">
        <v-btn text @click="close()"> Cancelar </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="selectClient()"> Selecionar </v-btn>
      </v-card-actions>
      <v-card-actions v-if="selected_tab === 'register'">
        <v-btn text @click="close()" :disabled="isLoading"> Cancelar </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="registerClient()" :disabled="isLoading"> Cadastrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalManageClient',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      search_term: null,
      list: [],
      selected: null,
      selected_tab: 'search',
      show_password: false,
      register_client: {
        gender: 'male',
        name: null,
        phone: null,
        client_classification_id: null,
        cpf_cnpj: null,
        password: undefined
      }
    };
  },
  computed: {
    client_classifications() {
      return this.$store.getters['ClientClassification/classifications'];
    }
  },
  methods: {
    skipStep() {
      this.$emit('close', this.$store.getters['Auth/client_default']);
    },
    close(data) {
      const serivceOrderClient = this.$store.getters['ServiceOrder/client'];
      if (data) {
        this.$emit('close', data);
      } else if (!serivceOrderClient) {
        this.$emit('close', this.$store.getters['Auth/client_default']);
      } else {
        this.$emit('close');
      }
    },
    getClientList() {
      const self = this;
      if (!self.search_term || self.search_term.length === 0) {
        return;
      }
      self.isLoading = true;
      self.$http
        .get('/clients', {
          params: {
            name: self.search_term
          }
        })
        .then((response) => {
          self.list = response.data.rows;
          self.isLoading = false;
        })
        .catch(() => {
          self.isLoading = false;
        });
    },
    changeTab(tab) {
      this.selected_tab = tab;
      this.register_client = {
        gender: 'male',
        name: null,
        phone: null,
        client_classification_id: this.client_classifications?.[0]?.id,
        cpf_cnpj: null
      };
    },
    selectClient() {
      const selected = this.list.find((client) => client.id === this.selected);
      this.close(selected);
    },
    registerClient() {
      const self = this;

      self.isLoading = true;

      try {
        self.$http.post(`/client/create`, self.register_client).then((r) => {
          self.close(r.data.created);
          self.register_client = {
            gender: 'male',
            name: null,
            phone: null,
            client_classification_id: null,
            cpf_cnpj: null,
            password: undefined
          };
        });
      } catch (e) {
        self.isLoading = false;
      } finally {
        self.isLoading = false;
      }
    },
    removePassword() {
      this.client.have_password = 0;
      this.client.password = null;
    },
    formatPhone(phone) {
      if (!phone) return '';  
      const cleanPhone = phone.replace(/\D/g, '');
      if (cleanPhone.length === 10) {
        return cleanPhone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }
      if (cleanPhone.length === 11) {
        return cleanPhone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }
      return phone;
    }
  },
  watch: {
    search_term: {
      handler(term) {
        if (term.length === 0) {
          this.list = [];
        }
      }
    }
  }
};
</script>

<style lang="scss">
.card-header-tabs {
  overflow: hidden;

  .header-tab {
    text-align: center;
    padding: 14px;
    overflow: hidden;
    width: 50%;
    float: left;

    &.selected {
      color: #fff;
      background-color: #48b38b;
    }
  }
}

.password-div {
  display: flex;
  align-items: center;
}
</style>
